import React from "react";
import SvgIcon from '@material-ui/core/SvgIcon';

function GroupIcon(props) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="20.041" height="15.628" viewBox="0 0 20.041 15.628" {...props}>
      <g id="Group_5834" data-name="Group 5834" transform="translate(-561.185 -404.14)">
        <g id="Group_5702" data-name="Group 5702">
          <g id="Ellipse_314" data-name="Ellipse 314">
            <path 
              id="Path_6499" 
              data-name="Path 6499" 
              d="M576.176,412.039a3.208,3.208,0,1,1,3.208-3.208A3.211,3.211,0,0,1,576.176,412.039Zm0-4.416a1.208,1.208,0,1,0,1.208,1.208A1.21,1.21,0,0,0,576.176,407.623Z"
              fill="currentColor" 
            />
          </g>
          <g id="Group_6284" data-name="Group 6284">
            <path 
              id="Path_6500" 
              data-name="Path 6500" 
              d="M577.812,412.786h-2.723a7.556,7.556,0,0,0-1.372.111,5.576,5.576,0,0,1,.942,1.889h3.153a1.417,1.417,0,0,1,1.414,1.415l.01.153c-.075.155-.816.733-3.073.733a11.043,11.043,0,0,1-1.34-.076,3.753,3.753,0,0,1-.834,1.893,11.508,11.508,0,0,0,2.174.183c3.733,0,5.063-1.379,5.063-2.67V416.2A3.418,3.418,0,0,0,577.812,412.786Z"
              fill="currentColor" 
            />
          </g>
        </g>
        <g id="Group_5703" data-name="Group 5703">
          <g id="Ellipse_315" data-name="Ellipse 315">
            <path 
              id="Path_6501" 
              data-name="Path 6501" 
              d="M567.237,411.647a3.753,3.753,0,1,1,3.754-3.753A3.757,3.757,0,0,1,567.237,411.647Zm0-5.507a1.753,1.753,0,1,0,1.754,1.754A1.757,1.757,0,0,0,567.237,406.14Z"
              fill="currentColor" 
            />
          </g>
          <g id="Path_6386" data-name="Path 6386">
            <path 
              id="Path_6502" 
              data-name="Path 6502" 
              d="M567.224,419.768c-5.451,0-6.039-2.157-6.039-3.084v-.269a4.019,4.019,0,0,1,4.01-4.013h4.083a4.02,4.02,0,0,1,4.013,4.012v.27C573.285,418.177,571.688,419.768,567.224,419.768ZM565.2,414.4a2.017,2.017,0,0,0-2.011,2.014v.268c0,.353.987,1.084,4.039,1.084,3.234,0,4.051-.92,4.067-1.089v-.264a2.017,2.017,0,0,0-2.014-2.013Z"
              fill="currentColor" 
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export default GroupIcon;


// WEBPACK FOOTER //
// ./src/components/icons/GroupIcon.jsx